import { useStore } from '@store/index';
import { removeOrgPrefix } from '@utils/routes';
import { useParams } from 'react-router-dom';

import { useShouldShowWebhooksPage } from '@/hooks/useShouldShowWebhooksPage';

/**
 * The organization the Webhooks pages act on (route `:orgId` first, then the
 * selected org) and the viewer's per-action webhook permissions for it.
 *
 * Customers only ever see their own organization here: there is no
 * organization filter, and every request carries this id in its path.
 */
export function useWebhooksOrg() {
  const { orgId } = useParams<{ orgId?: string }>();
  const selectedOrganizationId = useStore(state => state.selectedOrganizationId);
  const organizationId = (orgId ? removeOrgPrefix(orgId) : null) || selectedOrganizationId || '';
  const { permissions } = useShouldShowWebhooksPage({ organizationId: organizationId || null });
  return { organizationId, permissions };
}
